import React, {Suspense, lazy} from "react";
import {Route, Switch} from "react-router-dom";

const MainPage = lazy(() => import("../../index"));

const Routes = () => {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Switch>
                <Route exact path="/" component={MainPage}/>
            </Switch>
        </Suspense>
    );
}

export default Routes;
